import { Progress } from 'antd';
import "./index.css";

const ProgressBar = ({completed=0}) => {

  return <Progress percent={completed} showInfo={false} />
};

export default ProgressBar;
